module.exports = __webpack_public_path__ + "img/highlights1-s.3385e8d9.png";